import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Grid, Segment, SemanticSIZES } from 'semantic-ui-react';
import { PermitFormValues } from '../../../../app/models/permit';
import { WorkdestFormValidationSchema } from '../../../../app/common/form/FormikFormValidations';
import MyTextInput from '../../../../app/common/form/MyTextInput';
import MyZipCodeInput from '../../../../app/common/form/MyZipCodeInput';
import MyPhoneInput from '../../../../app/common/form/MyPhoneInput';

interface Props {
    propValues: PermitFormValues,
    prev: () => void,
    next: () => void,
    goTo: (step: number) => void,
    buttonSize: SemanticSIZES
}

export default observer(function PermitFormStep3WorkdestAddForm({ 
    propValues,
    prev,
    next,
    goTo,
    buttonSize
 }: Props) { 
    function handleFinalFormSubmit(formValues: PermitFormValues) { 
        propValues.workdestCompany = formValues.workdestCompany.trim();
        propValues.workdestAddress = formValues.workdestAddress.trim();
        propValues.workdestAddress2 = formValues.workdestAddress2.trim();
        propValues.workdestCity = formValues.workdestCity.trim();
        propValues.workdestState = formValues.workdestState.trim();
        propValues.workdestZipcode = formValues.workdestZipcode.trim();
        propValues.workdestPhone = formValues.workdestPhone.trim();

        if(propValues.isFinalView) {
            goTo(6);
        } else {
            next();
        }
    }

    return (
        <Formik
            initialValues={propValues}
            onSubmit={(values) => handleFinalFormSubmit(values)}
            validationSchema={WorkdestFormValidationSchema}
        >
        {({handleSubmit, isSubmitting, dirty, values, isValid}) => (
            <Form className='ui form error' onSubmit={handleSubmit} autoComplete='off'>
                <Grid>
                    <Grid.Column width={16}>
                        <Segment>
                            <label
                                className={values.workdestCompany ? 'label-visible input-label' : 'input-label'}
                            >Employer</label>
                            <MyTextInput name='workdestCompany' placeholder='Employer' tabIndex={1} />

                            <label
                                className={values.workdestAddress ? 'label-visible input-label' : 'input-label'}
                            >Address</label>
                            <MyTextInput name='workdestAddress' placeholder='Address' tabIndex={2} />

                            <label
                                className={values.workdestAddress2 ? 'label-visible input-label' : 'input-label'}
                            >Address 2</label>
                            <MyTextInput name='workdestAddress2' placeholder='Address 2' tabIndex={3} />

                            <label
                                className={values.workdestCity ? 'label-visible input-label' : 'input-label'}
                            >City</label>
                            <MyTextInput name='workdestCity' placeholder='City' tabIndex={4} />
                            
                            <label className={'label-visible input-label'}>State</label>
                            <Segment>WA</Segment>

                            <label
                                className={values.workdestZipcode ? 'label-visible input-label' : 'input-label'}
                            >Zip Code</label>
                            <MyZipCodeInput name='workdestZipcode' placeholder='Zip Code' tabIndex={5} />

                            <label
                                className={values.workdestPhone ? 'label-visible input-label' : 'input-label'}
                            >Phone</label>
                            <MyPhoneInput name='workdestPhone' placeholder='Phone' tabIndex={6} />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width={16}>
                        {!propValues.isFinalView &&
                            <Button
                                onClick={() => prev()}
                                content='Back'
                                size={buttonSize}
                            />
                        }
                        <Button 
                            disabled={!isValid}
                            loading={isSubmitting} 
                            floated='right'
                            positive
                            type='submit'
                            content={propValues.isFinalView ? 'Final Review' : 'Next'}
                            size={buttonSize}
                        /> 
                    </Grid.Column>
                </Grid>
            </Form>
        )}
        </Formik>
    )
})